export function loadImage(url) {
    return fetch(url, { method: 'HEAD' }).then((response) => {
        if (!response.ok)
            throw new Error(`Image not found at ${url}`);
        const image = new Image();
        image.src = url;
        return image;
    });
}
export function findFirstAvailableImageUrl(urls) {
    let index = 0;
    const tryNextUrl = () => {
        if (index >= urls.length) {
            return Promise.reject(new Error('No images available'));
        }
        return loadImage(urls[index])
            .then(() => urls[index])
            .catch((error) => {
            index++;
            return tryNextUrl();
        });
    };
    return tryNextUrl();
}
//# sourceMappingURL=image.js.map